import { SvgIcon } from "@mui/material";

function ArtificialIntelligence(props) {
    let colours = props.colours || ["#000"];
    return (
        <SvgIcon {...props} viewBox="50 50 412.000000 412.000000">
            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill={colours[0]} stroke="none">
                <path
                    d="M1697 4219 c-41 -24 -47 -58 -47 -279 l0 -210 -74 0 c-59 0 -79 -4
                -106 -22 -60 -41 -75 -71 -79 -159 l-3 -79 -210 0 c-280 0 -288 -4 -288 -150
                0 -77 2 -83 29 -111 l29 -29 221 0 221 0 0 -109 0 -110 -226 -3 -226 -3 -24
                -28 c-21 -25 -24 -38 -24 -113 0 -81 1 -87 29 -115 l29 -29 221 0 221 0 0
                -110 0 -110 -221 0 -221 0 -29 -29 c-28 -28 -29 -34 -29 -115 0 -75 3 -88 24
                -113 l24 -28 226 -3 226 -3 0 -110 0 -109 -221 0 -221 0 -29 -29 c-27 -28 -29
                -34 -29 -111 0 -146 8 -150 290 -150 l210 0 0 -74 c0 -59 4 -79 23 -106 40
                -60 70 -75 158 -79 l79 -3 0 -210 c0 -280 5 -288 156 -288 70 0 78 2 105 29
                l29 29 0 221 0 221 109 0 110 0 3 -226 3 -226 28 -24 c25 -21 38 -24 113 -24
                81 0 87 1 115 29 l29 29 0 221 0 221 110 0 110 0 0 -221 0 -221 29 -29 c28
                -28 34 -29 115 -29 75 0 88 3 113 24 l28 24 3 226 3 226 110 0 109 0 0 -221 0
                -221 29 -29 c27 -27 35 -29 105 -29 151 0 156 8 156 288 l0 210 79 3 c85 4
                114 18 155 73 16 21 22 46 25 107 l3 79 210 0 c280 0 288 5 288 156 0 70 -2
                78 -29 105 l-29 29 -221 0 -221 0 0 109 0 110 226 3 226 3 24 28 c21 25 24 38
                24 113 0 81 -1 87 -29 115 l-29 29 -221 0 -221 0 0 110 0 110 221 0 221 0 29
                29 c28 28 29 34 29 115 0 75 -3 88 -24 113 l-24 28 -226 3 -226 3 0 110 0 109
                221 0 221 0 29 29 c27 28 29 34 29 111 0 146 -8 150 -290 150 l-210 0 0 74 c0
                59 -4 79 -23 107 -40 60 -80 79 -163 79 l-74 0 0 210 c0 282 -4 290 -150 290
                -77 0 -83 -2 -111 -29 l-29 -29 0 -221 0 -221 -109 0 -110 0 -3 226 -3 226
                -28 24 c-25 21 -38 24 -113 24 -81 0 -87 -1 -115 -29 l-29 -29 0 -221 0 -221
                -110 0 -110 0 0 221 0 221 -29 29 c-28 28 -34 29 -115 29 -75 0 -88 -3 -113
                -24 l-28 -24 -3 -226 -3 -226 -110 0 -109 0 0 221 0 221 -29 29 c-28 27 -34
                29 -113 29 -46 0 -91 -5 -101 -11z m791 -1146 c5 -16 83 -228 172 -473 90
                -245 165 -453 168 -462 4 -17 -8 -18 -151 -18 l-155 0 -21 70 -22 71 -156 -3
                -156 -3 -22 -65 -22 -65 -153 -3 c-143 -2 -152 -1 -145 15 6 15 337 915 350
                951 3 9 43 12 154 12 l149 0 10 -27z m710 -460 l-3 -488 -150 0 -150 0 -3 488
                -2 487 155 0 155 0 -2 -487z"
                />
                <path
                    d="M2282 2627 c-23 -73 -42 -139 -42 -145 0 -8 28 -12 91 -12 69 0 90 3
86 13 -2 6 -21 72 -42 145 -22 72 -42 132 -45 132 -4 0 -25 -60 -48 -133z"
                />
            </g>
        </SvgIcon>
    );
}

export default ArtificialIntelligence;
